export function parseVenmoUsernameFromUrl(input) {
  if (!input) return null;

  const raw = String(input).trim();
  if (!raw) return null;

  // Allow direct username input like "@Tom-Cat-11"
  if (raw.startsWith("@") && raw.length > 1) return raw.slice(1);

  let url;
  try {
    url = new URL(raw);
  } catch {
    return null;
  }

  const host = url.hostname.toLowerCase();
  const parts = url.pathname.split("/").filter(Boolean);

  // QR/profile format: https://account.venmo.com/u/<username>
  if (host === "account.venmo.com" && parts[0] === "u" && parts[1]) {
    return decodeURIComponent(parts[1]);
  }

  // Public profile format: https://venmo.com/u/<username>
  if (host === "venmo.com" && parts[0] === "u" && parts[1]) {
    return decodeURIComponent(parts[1]);
  }

  // Common public profile format: https://venmo.me/<username>
  if (host === "venmo.me" && parts[0]) {
    return decodeURIComponent(parts[0]);
  }

  return null;
}

export function explainWhyVenmoUsernameNotParsed(input) {
  const raw = String(input || "").trim();
  if (!raw) return "empty";

  try {
    const url = new URL(raw);
    if (
      url.hostname.toLowerCase() === "venmo.com" &&
      url.pathname === "/code" &&
      url.searchParams.get("user_id")
    ) {
      return "venmo_code_user_id";
    }
  } catch {
    // ignore
  }

  return "unknown_format";
}

/**
 * Validates that each non-numeric hyphen-separated part starts with a capital letter.
 *
 * Examples:
 * - "Tom-Cat-11" ✅
 * - "John-Smith" ✅
 * - "yuan-yao-11" ❌
 *
 * Returns:
 * - null if valid (or empty)
 * - "capitalization" if invalid
 */
export function validateVenmoUsernameCapitalization(username) {
  const trimmed = String(username || "").trim().replace(/^@/, "");
  if (!trimmed) return null;

  const parts = trimmed.split("-").filter(Boolean);
  for (const part of parts) {
    if (/^\d+$/.test(part)) continue; // numeric suffix allowed
    const first = part[0];
    // If first is not a letter (e.g. '-', '_', emoji), treat as invalid
    if (first.toUpperCase() === first.toLowerCase()) return "capitalization";
    if (first !== first.toUpperCase()) return "capitalization";
  }
  return null;
}

export function isVenmoUsernameCapitalizationValid(username) {
  return !validateVenmoUsernameCapitalization(username);
}
